import React, { useState, useEffect } from 'react'
import './AddTransaction.css'

const currentDate = new Date();
let MExpenseDisplay;

const toIndianCurrency = (num) => {
    const curr = num.toLocaleString('en-IN', {
       style: 'currency',
       currency: 'INR'
    });
    return curr;
};

const MonthlyExpenseDisplay = () => {
    switch (currentDate.getMonth()){
        case 0:
            MExpenseDisplay = localStorage.getItem("$EJAN");
            break;
        case 1:
            MExpenseDisplay = localStorage.getItem("$EFEB");
            break;
        case 2:
            MExpenseDisplay = localStorage.getItem("$EMAR");
            break;
        case 3:
            MExpenseDisplay = localStorage.getItem("$EAPR");
            break;
        case 4:
            MExpenseDisplay = localStorage.getItem("$EMAY");
            break;
        case 5:
            MExpenseDisplay = localStorage.getItem("$EJUN");
            break;
        case 6:
            MExpenseDisplay = localStorage.getItem("$EJUL");
            break;
        case 7:
            MExpenseDisplay = localStorage.getItem("$EAUG");
            break;
        case 8:
            MExpenseDisplay = localStorage.getItem("$ESEP");
            break;
        case 9:
            MExpenseDisplay = localStorage.getItem("$EOCT");
            break;
        case 10:
            MExpenseDisplay = localStorage.getItem("$ENOV");
            break;
        case 11:
            MExpenseDisplay = localStorage.getItem("$EDEC");
            break;
    }
}

export const AddTransaction = (props) => {
    const [balance, setBalance] = useState(parseInt(localStorage.getItem("$BALANCE")));
    const [hcredit, setHcredit] = useState(parseInt(localStorage.getItem("$HCREDIT")))
    const [mexpense, setMexpense] = useState(parseInt(localStorage.getItem("$MEXPENSES")))
    const [hexpense, setHexpense] = useState(parseInt(localStorage.getItem("$HEXPENSES")))
    const [texpense, setTexpense] = useState(parseInt(localStorage.getItem("$TEXPENSES")))
    const [savings, setSavings] = useState(parseInt(localStorage.getItem("$SAVINGS")));

    const [sender, setSender] = useState("");
    const [receiver, setReceiver] = useState("");
    const [amount, setAmount] = useState();
    const [ttype, setTtype] = useState("Credit");
    const [desc, setDesc] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");

    const submit = (e)=> {
        e.preventDefault();
        let d = new Date(document.getElementById("date").value);
        if (!sender||!receiver||!amount||!time||!date){
            alert("Cannot be Blank!");
        }
        else{
            if (ttype==='Credit'){
                setBalance(parseInt(localStorage.getItem("$BALANCE")) + parseInt(amount));
                setTexpense(parseInt(localStorage.getItem("$TEXPENSES")) - parseInt(amount));
                if (parseInt(amount)>parseInt(localStorage.getItem("$HCREDIT"))){
                    setHcredit(parseInt(amount))
                }
                switch (d.getMonth()){
                    case 0:
                        localStorage.setItem("$EJAN", parseInt(localStorage.getItem("$EJAN"))-parseInt(amount));
                        break;
                    case 1:
                        localStorage.setItem("$EFEB", parseInt(localStorage.getItem("$EFEB"))-parseInt(amount));
                        break;
                    case 2:
                        localStorage.setItem("$EMAR", parseInt(localStorage.getItem("$EMAR"))-parseInt(amount));
                        break;
                    case 3:
                        localStorage.setItem("$EAPR", parseInt(localStorage.getItem("$EAPR"))-parseInt(amount));
                        break;
                    case 4:
                        localStorage.setItem("$EMAY", parseInt(localStorage.getItem("$EMAY"))-parseInt(amount));
                        break;
                    case 5:
                        localStorage.setItem("$EJUN", parseInt(localStorage.getItem("$EJUN"))-parseInt(amount));
                        break;
                    case 6:
                        localStorage.setItem("$EJUL", parseInt(localStorage.getItem("$EJUL"))-parseInt(amount));
                        break;
                    case 7:
                        localStorage.setItem("$EAUG", parseInt(localStorage.getItem("$EAUG"))-parseInt(amount));
                        break;
                    case 8:
                        localStorage.setItem("$ESEP", parseInt(localStorage.getItem("$ESEP"))-parseInt(amount));
                        break;
                    case 9:
                        localStorage.setItem("$EOCT", parseInt(localStorage.getItem("$EOCT"))-parseInt(amount));
                        break;
                    case 10:
                        localStorage.setItem("$ENOV", parseInt(localStorage.getItem("$ENOV"))-parseInt(amount));
                        break;
                    case 11:
                        localStorage.setItem("$EDEC", parseInt(localStorage.getItem("$EDEC"))-parseInt(amount));
                        break;
                }
            }
            else{
                setBalance(parseInt(localStorage.getItem("$BALANCE")) - parseInt(amount));
                setTexpense(parseInt(localStorage.getItem("$TEXPENSES")) + parseInt(amount));
                if (parseInt(amount)>parseInt(localStorage.getItem("$HEXPENSE"))){
                    setHexpense(parseInt(amount))
                }
                switch (d.getMonth()){
                    case 0:
                        localStorage.setItem("$EJAN", parseInt(localStorage.getItem("$EJAN"))+parseInt(amount));
                        break;
                    case 1:
                        localStorage.setItem("$EFEB", parseInt(localStorage.getItem("$EFEB"))+parseInt(amount));
                        break;
                    case 2:
                        localStorage.setItem("$EMAR", parseInt(localStorage.getItem("$EMAR"))+parseInt(amount));
                        break;
                    case 3:
                        localStorage.setItem("$EAPR", parseInt(localStorage.getItem("$EAPR"))+parseInt(amount));
                        break;
                    case 4:
                        localStorage.setItem("$EMAY", parseInt(localStorage.getItem("$EMAY"))+parseInt(amount));
                        break;
                    case 5:
                        localStorage.setItem("$EJUN", parseInt(localStorage.getItem("$EJUN"))+parseInt(amount));
                        break;
                    case 6:
                        localStorage.setItem("$EJUL", parseInt(localStorage.getItem("$EJUL"))+parseInt(amount));
                        break;
                    case 7:
                        localStorage.setItem("$EAUG", parseInt(localStorage.getItem("$EAUG"))+parseInt(amount));
                        break;
                    case 8:
                        localStorage.setItem("$ESEP", parseInt(localStorage.getItem("$ESEP"))+parseInt(amount));
                        break;
                    case 9:
                        localStorage.setItem("$EOCT", parseInt(localStorage.getItem("$EOCT"))+parseInt(amount));
                        break;
                    case 10:
                        localStorage.setItem("$ENOV", parseInt(localStorage.getItem("$ENOV"))+parseInt(amount));
                        break;
                    case 11:
                        localStorage.setItem("$EDEC", parseInt(localStorage.getItem("$EDEC"))+parseInt(amount));
                        break;
                }
                switch (currentDate.getMonth()){
                    case 0:
                        setMexpense(localStorage.getItem("$EJAN"));
                        break;
                    case 1:
                        setMexpense(localStorage.getItem("$EFEB"));
                        break;
                    case 2:
                        setMexpense(localStorage.getItem("$EMAR"));
                        break;
                    case 3:
                        setMexpense(localStorage.getItem("$EAPR"));
                        break;
                    case 4:
                        setMexpense(localStorage.getItem("$EMAY"));
                        break;
                    case 5:
                        setMexpense(localStorage.getItem("$EJUN"));
                        break;
                    case 6:
                        setMexpense(localStorage.getItem("$EJUL"));
                        break;
                    case 7:
                        setMexpense(localStorage.getItem("$EAUG"));
                        break;
                    case 8:
                        setMexpense(localStorage.getItem("$ESEP"));
                        break;
                    case 9:
                        setMexpense(localStorage.getItem("$EOCT"));
                        break;
                    case 10:
                        setMexpense(localStorage.getItem("$ENOV"));
                        break;
                    case 11:
                        setMexpense(localStorage.getItem("$EDEC"));
                        break;
                }
            }
            props.add_transaction(sender, receiver, amount, ttype, desc, time, date);
            setSender("");
            setReceiver("");
            setAmount("");
            setDesc("");
            setDate("");
            setTime("");
            if (ttype==="Credit" && amount>hcredit){
                setHcredit(parseInt(amount));
            }
            else if (ttype==="Debit" && amount>hexpense){
                setHexpense(parseInt(amount));
            }
        }
    }

    const addToSavings = () => {
        setSavings(parseInt(localStorage.getItem("$SAVINGS"))+parseInt(amount));
    }

  return (
    MonthlyExpenseDisplay(),
    localStorage.setItem("$BALANCE", parseInt(balance)),
    localStorage.setItem("$HCREDIT", parseInt(hcredit)),
    localStorage.setItem("$HEXPENSES", parseInt(hexpense)),
    localStorage.setItem("$TEXPENSES", parseInt(texpense)),
    localStorage.setItem("$MEXPENSES", parseInt(mexpense)),
    localStorage.setItem("$SAVINGS", parseInt(savings)),
    <>
    <div id="values-display" style={{backgroundColor:"rgb(16, 18, 57)", paddingTop:"20px"}}>
    <div id="your-balance">
        <h1 className="heading">Your Balance</h1><br></br>
        <h1>{toIndianCurrency(parseInt(balance))}</h1>
    </div>
    <div style={{display: "flex", flexDirection: "row"}}>
        <div id="highest-credit"><br/>
                <h1 className="heading-2">Your Highest Credit till now:</h1><br></br>
                <h2>{toIndianCurrency(parseInt(hcredit))}</h2>
        </div>
        <div id="highest-debit">
            <div>
                <h1 className="heading">Your Monthly Expenses</h1><br></br>
                <h1>{toIndianCurrency(parseInt(MExpenseDisplay))}</h1>
            </div><br/><br/><br/>
            <div>
                <h2 className="heading-2">Your Highest Expense till now:</h2><br></br>
                <h2>{toIndianCurrency(parseInt(hexpense))}</h2>
            </div>
        </div>
        <div id="your-savings"><br/>
            <h1 className="heading">Your Savings:</h1><br></br>
            <h1>{toIndianCurrency(parseInt(savings))}</h1>
            <br/><br/><br/>
        </div>
    </div>
  </div>
        <div id="form">
            <form onSubmit={submit}>
            <h1 style={{color: "white", fontSize: "40px", marginLeft: "120px"}}>Add your Transaction</h1><br/><br/><br/><br/>
            <div className="data">
                <label>Sender :</label>
                <input type="text" required className="textbox" id="name" value={sender} onChange={(e)=>{setSender(e.target.value)}}/>
            </div><br/><br/>
            <div className="data">
                <label>Receiver :</label>
                <input type="text" required className="textbox" id="name" value={receiver} onChange={(e)=>{setReceiver(e.target.value)}}/>
            </div><br/><br/>
            <div className="data">
                <label>Amount :</label>
                <input type="number" required className="textbox" id="name" value={amount} onChange={(e)=>{setAmount(e.target.value)}}/>
            </div><br/><br/>
            <div className="data">
                <label>Select Transaction Type :</label>
                <select name="ttype" id="ttype" className="input-opt" value={ttype} onChange={(e)=>{setTtype(e.target.value)}}>
                    <option value="Credit">Credit</option>
                    <option value="Debit">Debit</option>
                </select>
            </div><br/><br/>
            <div className="data">
                <label>Date :</label>
                <input type="date" required className="textbox" id="date" value={date} onChange={(e)=>{setDate(e.target.value)}}/>
            </div><br/><br/>
            <div className="data">
                <label>Time :</label>
                <input type="time" required className="textbox" id="name" value={time} onChange={(e)=>{setTime(e.target.value)}}/>
            </div><br/><br/>
            <div className="data">
                <label>Description :</label>
                <textarea className="textbox message"  value={desc} required onChange={(e)=>{setDesc(e.target.value)}}></textarea>
            </div><br/>
            <div className="btn">
                <button type="submit" id="addt">Add Transaction</button>
                <button type="submit" id="addtosavings" onClick={addToSavings}>Add to Savings</button>
                <button type="reset" id="reset" onClick={()=>{setSender("");setReceiver("");setAmount("");setDesc("");}}>Reset</button>
            </div>
            </form>
        </div>
    </>
  )
}
